import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBlossom = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 60 58",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.43 41.52c3.84-2.98 18.8-4.52 29.74.94 10.94 5.46 20.98 13.25 6.95 13.25-14.03 0-32.68 1.35-43.43 1.35s2.89-12.56 6.74-15.54Z",
		fill: "#53412F"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0 5.92c.75 5.72 2.33 9.14 4.74 10.26 9 4.15 22.1 2.42 23.24 4.04 1.62 2.26 1.62 9.47 0 21.62h3.9c-.53-12.47-.53-19.38 0-20.74.55-1.4 2.1-1.3 3.93-1.88 2.8-.89 11.05-.36 16.7-4.9 2.23-1.78 4.72-6.17 7.49-13.17-13.46-3.47-21.52.92-24.19 13.18-.58 2.65-5.71 5.46-6.25 3.92C24.95 5.06 15.1.95 0 5.92Z",
		fill: "#09FF79"
	})]
});
export default SvgBlossom;
